import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WebChatSurveyCompleted } from './WebChatSurveyCompleted';
import { WebChatSurveyFeedbackQuestion } from './WebChatSurveyFeedbackQuestion';
const WebChatSurveyFeedbackEvent = props => {
    let style = null;
    if (props.color) {
        style = {
            alignItems: 'center',
            backgroundColor: 'var(--goto-ui-background)',
            borderColor: props.color,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            '--goto-icon-color': props.color,
        };
    }
    const { response, feedbackQuestion } = props.surveyInfo;
    return (_jsx(_Fragment, { children: response ? (_jsx(WebChatSurveyCompleted, Object.assign({}, props, { style: style }), void 0)) : feedbackQuestion ? (_jsx(WebChatSurveyFeedbackQuestion, Object.assign({}, props, { style: style }), void 0)) : null }, void 0));
};
export default WebChatSurveyFeedbackEvent;
//# sourceMappingURL=WebChatSurveyFeedbackEvent.js.map